<ng-container *transloco="let t">
  <authority-labs-check-case
    [inspection]="inspection"
    [fieldSection]="fieldSection"
    [printPreview]="printPreview"
    [readonly]="readonly"
    (dataChange)="onChange()"
  >
    <mat-form-field
      dir="ltr"
      class="numerical"
      floatLabel="always"
      appearance="fill"
    >
      <mat-label>{{ t('inspection.fields.time') }}</mat-label>
      <input
        type="number"
        min="0"
        matInput
        placeholder="0"
        [drawableField]="
          (fieldSection || '') + ':' + (inspection?.title || '') + ':time'
        "
        [drawableFieldTitle]="t('inspection.fields.time')"
        [drawableFieldReadonly]="readonly"
        [(ngModel)]="inspection.time"
        [readonly]="readonly || printPreview"
        (input)="onChange()"
      />
      <span class="prefix" matSuffix>min</span>
    </mat-form-field>
  </authority-labs-check-case>
</ng-container>
